export const getImageName = () => {
  const randoms = "ABCDEFGHIJKLMNOPqrstuvwxyz0123456789".split('');
  let imageBaseName = new Date().getTime();
  let randomName = '';
  while (randomName.length < 5) {
    randomName += randoms[Math.floor(Math.random() * randoms.length)];
  }
  return imageBaseName + randomName;
}